function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.28 14.133c-.595 0-1.076.398-1.076.89v9.483c0 .491.481.89 1.076.89h1.435c.594 0 1.076-.399 1.076-.89v-9.483c0-.492-.482-.89-1.076-.89H15.28zM18.944 16.8c0-.49.481-.889 1.076-.889h1.434c.595 0 1.077.398 1.077.89v7.705c0 .491-.482.89-1.076.89H20.02c-.595 0-1.076-.399-1.076-.89V16.8zM10.54 17.69c-.594 0-1.076.398-1.076.889v5.927c0 .491.482.89 1.076.89h1.435c.594 0 1.076-.399 1.076-.89v-2.962a.25.25 0 00-.003-.04l.002-2.925c0-.49-.481-.89-1.076-.89H10.54z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.464 2a1 1 0 10-2 0v2.733H3.867A2.867 2.867 0 001 7.6v20.533A2.867 2.867 0 003.867 31h24.266A2.867 2.867 0 0031 28.133V7.6a2.867 2.867 0 00-2.867-2.867h-4.602V2a1 1 0 10-2 0v2.733H10.464V2zm17.67 4.733c.478 0 .866.388.866.867v1.8H3V7.6c0-.479.388-.867.867-.867h24.266zm.866 21.4V11.4H3v16.733c0 .479.388.867.867.867h24.266a.867.867 0 00.867-.867z",
  fill: "currentColor"
})));